module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_troms_og_finnmark_pos.cd9cade9.png";